// Used in login and password reset pages
import { initCore } from 'src/lib/init.js'

import 'src/styles/login.less'

initCore()

// disable scroll behaviour on wheel
document.addEventListener("wheel", function(){
    if(document.activeElement.type === "number"){
        document.activeElement.blur();
    }
});
